import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    sidebar: true,
}

const uiSlice = createSlice({
    initialState,
    name: "ui",
    reducers: {
        set_sidebar: (state, action) => {
            state.sidebar = action.payload;
            return state
        },
    }
})

export default uiSlice.reducer;

export const {
    set_sidebar,
} = uiSlice.actions;
